import PropTypes from 'prop-types'
import React from 'react'

import FormSection from '../../shared/components/FormSection'
import TextInput from '../../shared/components/TextInput'
import TextArea from '../../shared/components/TextArea'

const VisitFormSection = ({
  validationObj,
  openingHours,
  drivingInstructions,
  entryFeeAdults,
  entryFeePupils,
  entryFeeGroups,
  minGroupSize,
  show,
  readOnly,
  onChange,
  fieldSpecs
}) => {
  return (
    <FormSection
      title="3. Besuch"
      show={show}
    >

      <TextArea
        name="openingHours"
        value={openingHours}
        isValid={validationObj.openingHours}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.openingHours}
      />

      <TextArea
        name="drivingInstructions"
        value={drivingInstructions}
        isValid={validationObj.drivingInstructions}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.drivingInstructions}
      />

      <hr />

      <TextInput
        size={4}
        name="entryFeeAdults"
        value={entryFeeAdults || 0}
        group={{ after: '€' }}
        isValid={validationObj.entryFeeAdults}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.entryFeeAdults}
      />

      <TextInput
        size={4}
        name="entryFeePupils"
        value={entryFeePupils || 0}
        group={{ after: '€' }}
        isValid={validationObj.entryFeePupils}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.entryFeePupils}
      />

      <TextInput
        size={4}
        name="entryFeeGroups"
        value={entryFeeGroups || 0}
        group={{ after: '€' }}
        info="(Pro Schüler)"
        isValid={validationObj.entryFeeGroups}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.entryFeeGroups}
      />

      <TextInput
        size={3}
        name="minGroupSize"
        value={minGroupSize || 0}
        isValid={validationObj.minGroupSize}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.minGroupSize}
      />
    </FormSection>
  )
}

VisitFormSection.propTypes = {
  drivingInstructions: PropTypes.string,
  entryFeeAdults: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  entryFeeGroups: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  entryFeePupils: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  fieldSpecs: PropTypes.object,
  minGroupSize: PropTypes.number,
  onChange: PropTypes.func,
  openingHours: PropTypes.string,
  readOnly: PropTypes.bool,
  show: PropTypes.bool,
  validationObj: PropTypes.object,
}

export { VisitFormSection as default }



// WEBPACK FOOTER //
// ./src/museum/components/03-VisitFormSection.js